import React, { useState, useContext } from "react";
import { UserContext } from "../../UserContext";
import { Box, Typography } from "@mui/material";
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Button from "../elements/Button";
import DatePicker from "react-datepicker";
import axios from "axios";

export const CreateTrip = () => {
   const { user } = useContext(UserContext);
   const [startDate, setStartDate] = useState(new Date()); 
   const [endDate, setEndDate] = useState(new Date()); 
   const [formData, setFormData] = useState({
         tripName: '',
         destination: '',
         startDate: '',
         endDate: '',
         budget: '',
         image: null
   });

  const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
  }

  const handleImageChange = (e) => {
      setFormData({ ...formData, image: e.target.files[0] });
  }

  const handleSubmit = async (e) => {
      e.preventDefault();

      const { tripName, destination, startDate, endDate, budget, image } = formData;

      const formDataToSend = new FormData();
      formDataToSend.append('tripName', tripName);
      formDataToSend.append('destination', destination);
      formDataToSend.append('startDate', startDate);
      formDataToSend.append('endDate', endDate);
      formDataToSend.append('budget', budget);
      formDataToSend.append('image', image);

      try {
          const response = await axios.post('/api/create-itinerary', formDataToSend, {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          });

          console.log(response.data);
      } catch (error) {
          console.error('Error:', error.response.data);
      }
  }

  if (!user) {
      window.location.href= "/login"
  }

   return(
      <Box display="flex" justifyContent="center" margin="10px">
         <Box maxWidth="sm">
            <form onSubmit={handleSubmit} className="mx-auto"> 
               <Box>
               <img
                     src={formData.image ? URL.createObjectURL(formData.image) : require("../../assets/images/rectangle.png")}
                     alt="cover"
                     className="my-4"
               />
               <span>
                     <label htmlFor="image-upload" className="bg-white px-6 round coverphoto">
                        <InsertPhotoIcon className="inline" />
                        <Typography
                           variant="h6"
                           className="text-gray inline"
                           sx={{
                                 fontSize: "12px"
                           }}
                        >
                           Change cover photo
                        </Typography>
                     </label>
                     <input
                        type="file"
                        id="image-upload"
                        name="image"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="hidden"
                     />
                        </span>
               </Box>              
               <Box className="my-4">
                  <label>
                     Trip Name <br />
                     <input
                        name="tripName"
                        type="text"
                        placeholder="e.g., New York"
                        className="..."
                        onChange={handleInputChange}
                     />
                  </label>
               </Box>
               <Box display="flex">
               <Box className="w-full mt-4 mb-4 space-x-4">
               <label htmlFor="startDate">
                     Choose Date <br />
                        <DatePicker
                           // showIcon
                           selected={startDate}
                           onChange={(date) => setStartDate(date)}
                           className="
                           rounded-md
                           border
                           border-[#E9EDF4]
                           py-3
                           px-5
                           bg-[#FCFDFE]
                           text-gray
                           placeholder-[#ACB6BE]
                           outline-none
                           focus-visible:shadow-none
                           focus:border-pry
                        "
                        />
                  </label>
               </Box>
               <Box className="w-full mt-4 mb-4 space-x-4">
               <label htmlFor="endDate">
                     Choose Date <br />
                        <DatePicker
                           selected={endDate}
                           onChange={(date) => setEndDate(date)}
                           className="
                           rounded-md
                           border
                           border-[#E9EDF4]
                           py-3
                           px-5
                           bg-[#FCFDFE]
                           text-gray
                           placeholder-[#ACB6BE]
                           outline-none
                           focus-visible:shadow-none
                           focus:border-pry
                        "
                        />
                     </label>
               </Box>
               </Box>
               <Box className="mb-3">
               <label htmlFor="budget">
                     Budget <br />
                     <span className="relative inset-y-9 left-0 flex items-center pl-3">
                        <MonetizationOnIcon /> 
                     </span>
                     <input
                        name="budget"
                        type="number"
                        placeholder="Enter budget"
                        className="
                           w-full
                           rounded-md
                           border
                           border-[#E9EDF4]
                           py-3
                           px-10  {/* Adjust padding to give space for the icon */}
                           bg-[#FCFDFE]
                           text-gray
                           placeholder-[#ACB6BE]
                           outline-none
                           focus-visible:shadow-none
                           focus:border-pry
                           pl-10  {/* Adjust padding to give space for the icon */}
                        "
                     />
                  </label>
               </Box>
               <Box className="mb-3">
               <label htmlFor="invite">
                     Invite Friends <br />
                     <span className="relative inset-y-9 left-0 flex items-center pl-3">
                        <GroupAddIcon /> 
                     </span>
                     <select
                        name="invite"
                        type="text"
                        className="
                           w-full
                           rounded-md
                           border
                           border-[#E9EDF4]
                           py-3
                           px-5
                           bg-[#FCFDFE]
                           text-gray
                           placeholder-[#ACB6BE]
                           outline-none
                           focus-visible:shadow-none
                           focus:border-pry
                        "
                     >
                        <option value="Add Friends"></option>
                        <option value=""></option>
                     </select>
                  </label>
               </Box>
               <Box className="mt-[-6%] mb-5 w-full">
                  <Button type="submit" size="large" className="px-6">Create Itinerary</Button>
                  <Typography 
                     variant="h6" 
                     paragraph
                     sx={{
                        fontWeight: "400",
                        textAlign: "center",
                        marginTop: "10px",
                        marginBottom: "50px",
                        fontSize: "14px"
                     }}
                     className="text-gray-500"
                  >
                     Cancel
                  </Typography>
               </Box>
            </form>
         </Box>
      </Box>
   )
}
